import { useTranslation } from "@outschool/localization";
import {
  ModalActionButtons,
  Select
} from "@outschool/ui-legacy-component-library";
import React from "react";

import * as EnrollmentPaymentRefund from "../../../shared/EnrollmentPaymentRefund";
import { useParentRefundReasonLabels } from "./useParentRefundReasonLabels";

type StopSubscriptionReasonFormProps = {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
  handleClose: () => void;
  reasonInputRef: React.Ref<HTMLSelectElement>;
  reason: string;
  noteInputRef: React.Ref<HTMLTextAreaElement>;
  note: string;
  onReasonDropdownChange: (value: string) => void;
  onReasonNoteChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  mutationInProgress: boolean;
};

export default function StopSubscriptionReasonForm({
  handleSubmit,
  handleClose,
  reasonInputRef,
  reason,
  noteInputRef,
  note,
  onReasonDropdownChange,
  onReasonNoteChange,
  mutationInProgress
}: StopSubscriptionReasonFormProps) {
  const { t } = useTranslation(
    "client\\components\\account\\StopSubscriptionReasonForm"
  );
  const parentRefundReasonLabels = useParentRefundReasonLabels();
  return (
    <form onSubmit={handleSubmit}>
      {t("Why are you stopping your subscription? (optional)")}
      <Select
        name="reason"
        options={EnrollmentPaymentRefund.PARENT_REFUND_REASON_OPTIONS.map(
          optionValue => ({
            value: optionValue,
            label: parentRefundReasonLabels[optionValue]
          })
        )}
        ref={reasonInputRef}
        value={reason}
        placeholder={t("Choose a reason...")}
        onChange={onReasonDropdownChange}
        sx={{
          width: "100%",
          boxSizing: "border-box",
          marginBottom: "0.5em"
        }}
      ></Select>
      <div>{t("Say more about your decision to stop your subscription:")}</div>
      <textarea
        value={note}
        onChange={onReasonNoteChange}
        name="noteInput"
        ref={noteInputRef}
        placeholder={t("(optional) Message for teacher and Outschool")}
        rows={2}
        style={{
          width: "100%",
          boxSizing: "border-box",
          marginBottom: "0.5em",
          height: "auto"
        }}
      ></textarea>
      <ModalActionButtons
        onCancel={handleClose}
        primaryLabel={
          mutationInProgress
            ? t("Stopping subscription...")
            : t("Stop subscription")
        }
        primaryType="submit"
        disabled={mutationInProgress}
      />
    </form>
  );
}
